/* Back9Relief — Revamped PDP behaviour.
   Vanilla, no dependencies, no third-party scripts. */
(function () {
  'use strict';

  // Nine sections each ask for this file. The browser fetches it once but runs
  // it once per tag, so everything below would be parsed and bound nine times.
  // Run the whole thing once and let the section:load listener handle re-renders.
  if (window.__b9rPdpLoaded) return;
  window.__b9rPdpLoaded = true;

  /* ---------------------------------------------------------- gallery -- */
  /* Scroll-snap track. The slide is 88% wide so the next image peeks in
     at the edge — that peek is what tells people there is more to see. */
  function initGallery(root) {
    var track = root.querySelector('[data-b9r-track]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-b9r-slide]');
    var dots = root.querySelectorAll('[data-b9r-dot]');
    var prev = root.querySelector('[data-b9r-prev]');
    var next = root.querySelector('[data-b9r-next]');
    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    function index() {
      // measured off the slides themselves; the old version assumed a 12px
      // gap between them, which no longer exists now they are full width
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestGap = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var centre = slides[i].offsetLeft - track.offsetLeft + slides[i].offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      }
      return best;
    }

    function go(i) {
      var clamped = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: slides[clamped].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function sync() {
      var i = index();
      dots.forEach(function (dot, n) {
        dot.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
    }

    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    dots.forEach(function (dot, n) {
      dot.addEventListener('click', function () { go(n); });
    });

    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  }

  /* ------------------------------------------------------- accordions -- */
  function initAccordion(root) {
    root.querySelectorAll('[data-b9r-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
      });
    });
  }

  /* --------------------------------------------------------- countdown -- */
  // Last second of the current month in Toronto time, so a monthly sale
  // rolls over on its own instead of someone re-dating it every month.
  var torontoClock = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Toronto', hourCycle: 'h23',
    year: 'numeric', month: 'numeric', day: 'numeric',
    hour: 'numeric', minute: 'numeric', second: 'numeric'
  });
  function torontoParts(ms) {
    var parts = {};
    torontoClock.formatToParts(ms).forEach(function (p) { parts[p.type] = +p.value; });
    return parts;
  }
  function torontoOffset(ms) {
    var p = torontoParts(ms);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - Math.floor(ms / 1000) * 1000;
  }
  function endOfMonthToronto(now) {
    var p = torontoParts(now);
    // Day 0 of next month is the last day of this one.
    var wall = Date.UTC(p.year, p.month, 0, 23, 59, 59);
    // Take the offset at the deadline itself, not now: the clocks may change in between.
    var guess = wall - torontoOffset(now);
    return wall - torontoOffset(guess);
  }

  // Julian (Oct 29): the sale clock is a 24-hour timer that resets at midnight Toronto time,
  // so "monthly" mode counts down to the end of today; the sale itself never ends.
  function endOfDayToronto(now) {
    var p = torontoParts(now);
    var wall = Date.UTC(p.year, p.month - 1, p.day, 23, 59, 59);
    var guess = wall - torontoOffset(now);
    return wall - torontoOffset(guess);
  }

  function initCountdown(el) {
    var monthly = el.dataset.endMode === 'monthly';
    var end = monthly ? endOfDayToronto(Date.now()) : new Date(el.dataset.endTime).getTime();
    if (isNaN(end)) return;

    var fields = {
      days: el.querySelector('[data-unit="days"]'),
      hours: el.querySelector('[data-unit="hours"]'),
      minutes: el.querySelector('[data-unit="minutes"]'),
      seconds: el.querySelector('[data-unit="seconds"]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0 && monthly) {
        end = endOfDayToronto(Date.now() + 1000);
        diff = end - Date.now();
      }
      if (diff <= 0) {
        // Real deadline reached: hide the bar rather than resetting it.
        var bar = el.closest('[data-b9r-promo]');
        if (bar) {
          bar.hidden = true;
          // The spacer holds the bar's height (display:block !important in the CSS,
          // so only an inline important beats it); left, it is an empty strip.
          var spacer = bar.parentNode.querySelector('[data-b9r-promo-spacer]');
          if (spacer) spacer.style.setProperty('display', 'none', 'important');
        }
        clearInterval(timer);
        return;
      }
      var s = Math.floor(diff / 1000);
      if (fields.days) fields.days.textContent = pad(Math.floor(s / 86400));
      if (fields.hours) fields.hours.textContent = pad(Math.floor((fields.days ? s % 86400 : s) / 3600));
      if (fields.minutes) fields.minutes.textContent = pad(Math.floor((s % 3600) / 60));
      if (fields.seconds) fields.seconds.textContent = pad(s % 60);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------------- buy box ----- */
  function initBuyBox(root) {
    var form = root.querySelector('form.b9r-form');
    if (!form) return;

    var sizeSelect = form.querySelector('[data-b9r-size]');
    var qtyInput = form.querySelector('[data-b9r-qty]');
    var submit = form.querySelector('[data-b9r-submit]');
    var tiers = form.querySelectorAll('[data-b9r-tier]');
    var savingsOut = form.querySelector('[data-b9r-savings]');
    var sizeGroups = form.querySelectorAll('[data-b9r-sizes]');
    var giftGroups = form.querySelectorAll('[data-b9r-gift-items]');
    var requireSize = root.dataset.requireSize === 'true';
    var perUnit = sizeGroups.length > 0;

    var labels = {
      chooseSize: submit ? submit.dataset.labelChooseSize : '',
      add: submit ? submit.dataset.labelAdd : ''
    };

    /* The bar at the bottom of the page mirrors this buy box: same gate,
       same two labels, and it is the only way back to the size fields
       once the shopper has scrolled past them. */
    var stickyBtn = document.querySelector('[data-b9r-sticky-jump]');
    var stickyLabels = stickyBtn ? {
      chooseSize: stickyBtn.dataset.labelChooseSize || labels.chooseSize,
      add: stickyBtn.dataset.labelAdd || labels.add
    } : null;
    /* Any other button that wants the sticky bar's behaviour (the closing
       offer's CTA at the foot of the page): same label swap, same click. */
    var jumpBtns = Array.prototype.slice.call(document.querySelectorAll('[data-b9r-cta-jump]'));

    function currentTier() {
      return form.querySelector('[data-b9r-tier]:checked') || tiers[0] || null;
    }

    /* Only the selected tier's size fields are submitted. Disabled fields
       are left out of the POST, which keeps the items[] indices clean. */
    function applyTierFields(tier) {
      if (!tier) return;
      var pos = tier.dataset.tierPos;
      if (perUnit) {
        sizeGroups.forEach(function (group) {
          var active = group.dataset.tierPos === pos;
          group.hidden = !active;
          group.querySelectorAll('select, input').forEach(function (field) {
            field.disabled = !active;
          });
        });
      }
      /* The bonuses are real line items, so they follow the same rule as the
         sizes: only the selected tier's are live. Their list stays visible
         either way — a shopper comparing tiers wants to see what each one
         includes; it is only the POST they must stay out of. */
      giftGroups.forEach(function (group) {
        var active = group.dataset.tierPos === pos;
        group.querySelectorAll('input').forEach(function (field) {
          field.disabled = !active;
        });
      });
    }

    function missingSize() {
      if (!requireSize) return null;
      if (perUnit) {
        var tier = currentTier();
        if (!tier) return null;
        var group = form.querySelector('[data-b9r-sizes][data-tier-pos="' + tier.dataset.tierPos + '"]');
        if (!group) return null;
        var empty = null;
        group.querySelectorAll('[data-b9r-unit-size]').forEach(function (sel) {
          if (!empty && sel.value === '') empty = sel;
        });
        return empty;
      }
      return sizeSelect && sizeSelect.value === '' ? sizeSelect : null;
    }

    function sync() {
      var tier = currentTier();
      applyTierFields(tier);

      if (tier && qtyInput) qtyInput.value = tier.dataset.quantity || '1';

      if (submit) {
        var ready = !missingSize();
        /* Live even with no size yet. A greyed button reads as "broken" or
           "nothing for you here", and leaves someone who has picked an offer
           with no obvious next move. Live, it is the next move: it carries
           them to the size picker for the offer they chose. The capture-phase
           click handler below refuses to submit until a size is in, so it
           still cannot reach the cart half-filled - which is what the
           disabled attribute was there to guarantee. */
        submit.disabled = false;
        submit.removeAttribute('aria-disabled');
        submit.textContent = ready ? labels.add : labels.chooseSize;
        submit.dataset.ready = ready ? 'true' : 'false';
      }

      if (stickyBtn) {
        /* Never greyed. This one is always a live control: either it adds
           to cart, or it carries them up to the size fields. Only the
           label changes. */
        var stickyReady = !missingSize();
        stickyBtn.textContent = stickyReady ? stickyLabels.add : stickyLabels.chooseSize;
        stickyBtn.dataset.ready = stickyReady ? 'true' : 'false';
      }
      jumpBtns.forEach(function (b) {
        var r = !missingSize();
        b.textContent = r ? (b.dataset.labelAdd || labels.add) : (b.dataset.labelChooseSize || labels.chooseSize);
        b.dataset.ready = r ? 'true' : 'false';
      });
      document.dispatchEvent(new CustomEvent('b9r:sizes', { detail: { ready: !missingSize() } }));

      if (tier && savingsOut) {
        var saving = tier.dataset.savings || '';
        savingsOut.textContent = saving;
        var line = savingsOut.closest('.b9r-savings');
        if (line) line.hidden = saving === '';
      }

    }

    /* Picking a tier collapses the one that was open and expands the new
       one in the same frame. Tap Buy 3 while Buy 2 is open and Buy 2 loses
       ~340px above your thumb, so the card you tapped jumps up the screen.
       Browsers anchor scroll for content above the viewport, not inside it,
       so hold the tapped card where it was: note its top before the change
       and scroll by whatever it moved once layout settles. */
    tiers.forEach(function (tier) {
      // `tier` is the hidden radio; the thing under the thumb is its card.
      var card = tier.closest('.b9r-tier') || tier;
      var topBefore = null;
      var remember = function () { topBefore = card.getBoundingClientRect().top; };
      card.addEventListener('pointerdown', remember);
      card.addEventListener('keydown', remember);
      tier.addEventListener('change', function () {
        sync();
        if (topBefore === null) return;
        var was = topBefore;
        topBefore = null;
        // getBoundingClientRect forces layout, so this is already the
        // post-collapse position - no need to wait a frame.
        var moved = card.getBoundingClientRect().top - was;
        if (Math.abs(moved) > 1) {
          // Instant, explicitly. The theme sets scroll-behavior:smooth on
          // the page, so a plain scrollBy would ease over a few hundred ms
          // while the layout change had already painted - the card jumped
          // and then slid back, and the bigger the collapse the longer the
          // slide. This has to land in the same frame as the reflow.
          try {
            window.scrollBy({ top: moved, left: 0, behavior: 'instant' });
          } catch (e) {
            window.scrollBy(0, moved);
          }
        }
      });
    });
    if (sizeSelect) {
      sizeSelect.addEventListener('change', function () {
        sizeSelect.dataset.error = 'false';
        sync();
      });
    }
    form.querySelectorAll('[data-b9r-unit-size]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        sel.dataset.error = 'false';
        sync();
      });
    });

    /* One dropdown drives the real per-pair selects, and a line underneath
       says so in words. Nobody should have to work out whether picking one
       size covered all three pairs, or hunt for the way to split them. */
    sizeGroups.forEach(function (group) {
      var all = group.querySelector('[data-b9r-size-all]');
      if (!all) return;
      var sels = group.querySelectorAll('[data-b9r-unit-size]');
      var rows = group.querySelector('[data-b9r-size-rows]');
      var mode = group.querySelector('.b9r-sizemode');
      var more = group.querySelector('[data-b9r-sizes-toggle]');
      var moreText = group.querySelector('[data-b9r-sizes-toggle-text]');
      var state = group.querySelector('[data-b9r-size-state]');
      var stateText = group.querySelector('[data-b9r-size-state-text]');
      var n = sels.length;

      function say() {
        if (!stateText) return;
        if (rows && !rows.hidden) {
          stateText.textContent = 'Getting different sizes';
          return;
        }
        var picked = all.value
          ? all.options[all.selectedIndex].textContent.trim()
          : '';
        stateText.textContent = picked
          ? 'All ' + n + ' pairs: ' + picked
          : 'All ' + n + ' pairs get the same size';
      }

      all.addEventListener('change', function () {
        sels.forEach(function (sel) {
          sel.value = all.value;
          sel.dataset.error = 'false';
        });
        all.dataset.error = 'false';
        say();
        sync();
      });

      var same = group.querySelector('[data-b9r-size-same]');

      /* open = mixed sizes. The switch has two buttons, so tapping the side
         that is already on does nothing. */
      function setMixed(opening) {
        if (!rows || rows.hidden === !opening) return;
        rows.hidden = !opening;
        /* only one of the two is ever on screen: once the pairs differ the
           single dropdown no longer describes the order, and leaving it
           sitting there showing one size would be a lie */
        all.hidden = opening;
        if (mode) mode.dataset.open = opening ? 'true' : 'false';
        if (more) {
          more.setAttribute('aria-expanded', opening ? 'true' : 'false');
          more.setAttribute('aria-pressed', opening ? 'true' : 'false');
        }
        if (same) same.setAttribute('aria-pressed', opening ? 'false' : 'true');
        if (moreText) {
          moreText.textContent = opening
            ? 'Use one size for all ' + n
            : 'Need different sizes?';
        }
        /* No focus() on open. Inside a tap handler, focusing a <select>
           makes iOS and Android throw the native picker straight up, so the
           wheel appeared before anyone had seen the rows. The rows arriving
           is the feedback. */
        if (!opening) {
          /* coming back means one size again, so put it back */
          sels.forEach(function (sel) { sel.value = all.value; });
        }
        say();
        sync();
      }

      if (more && rows) {
        more.addEventListener('click', function () {
          /* the two-way switch only ever turns mixing on; the old single
             button toggled */
          setMixed(same ? true : rows.hidden);
        });
      }
      if (same) same.addEventListener('click', function () { setMixed(false); });

      say();
    });

    /* One way to walk someone to the size they still owe us, used by the
       main button, the sticky bar and the form's own last-resort check, so
       all three land in the same place and look the same doing it. */
    function guideToSize(missing) {
      if (!missing) return;

      /* The per-pair selects sit inside a panel that stays collapsed until
         someone asks for mixed sizes, so the field that is actually empty is
         usually one nobody can see. Focusing that does nothing at all, and
         the button would feel dead. Aim at the control that is on screen -
         the single dropdown that sets every pair at once. */
      var target = missing;
      if (target.offsetParent === null) {
        var owner = missing.closest('[data-b9r-sizes]');
        var all = owner && owner.querySelector('[data-b9r-size-all]');
        if (all && all.offsetParent !== null) target = all;
      }

      target.dataset.error = 'true';
      scrollToField(target);
      window.setTimeout(function () {
        if (target.focus) target.focus({ preventScroll: true });
        /* A short ring, not a permanent red box: an untouched dropdown is
           not an error, it just needs to be the thing they look at next.
           On the dropdown itself - ringing the whole sizes block took in the
           "Size (US)" label row and the note above it, so the pulse sat far
           too high and looked like the group was misbehaving. */
        target.classList.remove('b9r-attn');
        void target.offsetWidth;                // restart, if it is already on
        target.classList.add('b9r-attn');
        window.setTimeout(function () { target.classList.remove('b9r-attn'); }, 1700);
      }, 450);
    }

    /* ----------------------------------------------- the add itself ---
       The store runs UpCart, a cart-drawer app that hijacks every add-to-cart
       click and re-posts the form as its own AJAX call. It only understands
       a single-product form (`id` + `quantity`). This form posts a bundle -
       items[0], items[1], items[2] and a gift - and UpCart wraps all of those
       into one flat object with no `id` in it, Shopify answers 400, and
       nothing reaches the cart. So the add is done here, with a payload
       Shopify actually accepts, and the drawer is refreshed and opened
       afterwards through UpCart's own hooks. If anything about that path
       fails, the form is submitted natively, which no script can intercept
       and which Shopify has always accepted for this shape of form. */
    function readItems() {
      var fd = new FormData(form);
      var rows = {};
      fd.forEach(function (value, key) {
        var m = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        var q = key.match(/^items\[(\d+)\]\[properties\]\[([^\]]+)\]$/);
        if (m) {
          rows[m[1]] = rows[m[1]] || {};
          rows[m[1]][m[2]] = parseInt(value, 10) || (m[2] === 'quantity' ? 1 : 0);
        } else if (q) {
          rows[q[1]] = rows[q[1]] || {};
          rows[q[1]].properties = rows[q[1]].properties || {};
          rows[q[1]].properties[q[2]] = value;
        }
      });
      var keys = Object.keys(rows);
      if (!keys.length) {
        // single-select mode posts a plain `id` + `quantity`
        var one = parseInt(fd.get('id'), 10);
        return one ? [{ id: one, quantity: parseInt(fd.get('quantity'), 10) || 1 }] : [];
      }
      /* One row per size selector, so two pairs in the same size arrive as
         two identical rows. Shopify merges those into one cart line, and its
         analytics listener then sees more rows sent than lines returned,
         gives up, and never emits product_added_to_cart - so Meta and GA
         missed every add from this page. Same id + same properties = one row. */
      var merged = [], seen = {};
      keys.sort(function (a, b) { return a - b; }).forEach(function (k) {
        var row = rows[k];
        if (!row.id) return;
        var sig = row.id + '|' + JSON.stringify(row.properties || {});
        if (seen[sig]) { seen[sig].quantity += row.quantity || 1; return; }
        seen[sig] = row; merged.push(row);
      });
      /* UK and EU shoppers pick from relabelled sizes ("UK 8"); the variant is
         still the US one ("M 9 / W 10"). A visible line-item note carries the
         size they actually chose into the cart, checkout and order email. */
      var sys = window.B9R_SIZE_SYS;
      if (sys === 'uk' || sys === 'eu') {
        var key = sys === 'uk' ? 'Size (UK)' : 'Size (EU)';
        merged.forEach(function (row) {
          if ((row.properties || {})._bundle_gift) return;
          var opt = form.querySelector('option[value="' + row.id + '"][data-' + sys + ']');
          if (!opt) return;
          row.properties = row.properties || {};
          row.properties[key] = opt.getAttribute('data-' + sys).replace(/\s*\(.*\)$/, '');
        });
      }
      return merged;
    }

    function nativeSubmit() {
      // HTMLFormElement.submit() fires no `submit` event, so no listener -
      // UpCart's included - gets a chance to interfere.
      if (typeof form.submit === 'function') form.submit();
    }

    function addToCart() {
      var items = readItems();
      if (!items.length || typeof window.fetch !== 'function') { nativeSubmit(); return; }

      var label = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'ADDING…';
      function restore() { submit.disabled = false; submit.textContent = label; }

      /* Shopify's analytics listener (Meta's AddToCart, GA) watches fetch()
         and counts one add per product in the request. One click on this
         button is one add, so only the insoles travel by fetch; the free
         gifts follow through XMLHttpRequest, which the listener ignores. */
      var main = [], gifts = [];
      items.forEach(function (row) { ((row.properties || {})._bundle_gift ? gifts : main).push(row); });
      if (!main.length) { main = gifts; gifts = []; }
      function xhrAdd(rows) {
        return new Promise(function (resolve) {
          if (!rows.length) { resolve(); return; }
          var x = new XMLHttpRequest();
          x.open('POST', '/cart/add.js');
          x.setRequestHeader('Content-Type', 'application/json');
          x.setRequestHeader('Accept', 'application/json');
          x.onload = x.onerror = function () { resolve(); };   // the drawer's ladder re-checks the gifts anyway
          x.send(JSON.stringify({ items: rows }));
        });
      }
      /* Gifts go in first. The drawer refreshes itself 50ms after any
         cart fetch and its ladder tops up whatever gifts the tier earns,
         so if the insoles landed first the ladder added a second set of
         gifts before the XHR ones arrived. With the gifts already in the
         cart the ladder finds them and adds nothing. */
      xhrAdd(gifts).then(function () {
        return window.fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: main })
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('cart/add ' + res.status);
        return res.json();
      }).then(function () {
        restore();
        if (window.b9rCart) {
          window.b9rCart.refresh().then(window.b9rCart.open, window.b9rCart.open);
        } else if (typeof window.upcartRefreshCart === 'function') {
          Promise.resolve(window.upcartRefreshCart()).then(function () {
            if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
          }, function () { window.location.href = '/cart'; });
        } else {
          window.location.href = '/cart';
        }
      }).catch(function () {
        restore();
        nativeSubmit();
      });
    }

    // Tell UpCart to leave this form alone, whatever it passes to the hook.
    (function () {
      var previous = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function (arg) {
        try {
          var el = arg && (arg.target || arg.form || arg);
          if (el === form) return true;
          if (el && el.closest && el.closest('form') === form) return true;
        } catch (e) {}
        return typeof previous === 'function' ? previous.apply(this, arguments) : false;
      };
    })();

    if (submit) {
      /* Capture, so this runs before the theme's or a cart app's own submit
         handler can see the click at all. */
      submit.addEventListener('click', function (event) {
        var missing = missingSize();
        event.preventDefault();
        event.stopImmediatePropagation();
        if (missing) { guideToSize(missing); return; }
        addToCart();
      }, true);
    }

    jumpBtns.forEach(function (b) {
      b.addEventListener('click', function (event) {
        event.preventDefault();
        var missing = missingSize();
        if (!missing) { if (submit) submit.click(); return; }
        guideToSize(missing);
      });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (event) {
        event.preventDefault();
        var missing = missingSize();

        if (!missing) {
          // Sizes are in. Click the real button so one code path does the
          // validating and the adding - a click, not requestSubmit(), so it
          // goes through the capture handler above rather than raising a
          // `submit` event that UpCart would catch.
          if (submit && !submit.disabled) submit.click();
          return;
        }

        // Take them to the field that is still empty and flag it.
        guideToSize(missing);
      });
    }

    form.addEventListener('submit', function (event) {
      var missing = missingSize();
      event.preventDefault();
      event.stopImmediatePropagation();
      if (missing) { guideToSize(missing); return; }
      addToCart();
    }, true);

    sync();
  }

  /* ------------------------------------------------------ scrolling --- */
  /* scrollIntoView({block:'center'}) can drop the field behind the fixed
     promo bar or under the sticky CTA on a short screen, so work out the
     offset ourselves. */
  function topOffset() {
    var offset = 0;
    document.querySelectorAll('.b9r-promo--sticky, .shopify-section-header-sticky, sticky-header').forEach(function (el) {
      var box = el.getBoundingClientRect();
      if (getComputedStyle(el).position === 'fixed' && box.top <= 1) offset += box.height;
    });
    return offset;
  }

  function holdHeader() {
    window.__b9rHdrHold = Date.now() + 1600;
    document.querySelectorAll('.b9r-hdr--shown').forEach(function (w) { w.classList.remove('b9r-hdr--shown'); });
    var release = function () { window.__b9rHdrHold = Date.now() + 150; };
    if ('onscrollend' in window) window.addEventListener('scrollend', release, { once: true });
  }

  function scrollTo(el, pad) {
    if (!el) return;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = el.getBoundingClientRect().top + window.pageYOffset - topOffset() - (pad || 24);
    if (top < 0) top = 0;
    /* A jump back up the page reads to the smart header as the shopper
       scrolling up, so it slid the logo row in over the very box we were
       taking them to. Hold it tucked away until the jump has landed. */
    holdHeader();
    try {
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);          // older Safari takes two numbers only
    }
  }

  /* Land on the tier they chose, not on the top of the whole offer. The
     offer block starts with Buy 1; if Buy 3 is selected, its size dropdown
     sits several hundred pixels below that, so aiming at the block's top
     left the actual field low on the screen or off it. The selected tier's
     own top, with room above it, keeps the tier title, its price and the
     dropdown together in view. */
  function scrollToField(el) {
    if (!el) return;
    var tier = el.closest ? el.closest('.b9r-tier') : null;
    if (!tier) {
      var checked = document.querySelector('.b9r-tier__input:checked');
      tier = checked ? checked.closest('.b9r-tier') : null;
    }
    /* Kit: put the size dropdown in the middle of the screen, so the
       price and size info sit above it and the savings bar and button
       below. Never scroll so far that the card's totals go off the top. */
    var kit = el.closest ? el.closest('.b9r-kit') : null;
    var kitTop = kit ? kit.querySelector('.b9r-kit__totals') : null;
    if (kitTop) {
      var sel = kit.querySelector('[data-b9r-size]') || el;
      var head = topOffset();
      var r = sel.getBoundingClientRect();
      var want = r.top + window.pageYOffset + r.height / 2 - (head + (window.innerHeight - head) / 2);
      var limit = kitTop.getBoundingClientRect().top + window.pageYOffset - head - 16;
      var y = Math.max(0, Math.min(want, limit));
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      holdHeader();
      try { window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' }); }
      catch (e) { window.scrollTo(0, y); }
      return;
    }
    var offer = document.querySelector('[data-b9r-offer]');
    scrollTo(tier || offer || el, tier ? 16 : (offer ? 12 : 24));
  }

  /* ------------------------------------------------------ sticky bar --- */
  function initSticky(bar) {
    var anchor = document.querySelector('[data-b9r-sticky-anchor]');
    if (!anchor) return;

    /* Show the bar the moment the real Add to Cart button leaves the top
       of the screen, so there is never a stretch with no button at all. A plain scroll check rather than an observer:
       "is it above me" is a position question, and an observer only fires
       on threshold crossings, which makes the state after a jump or a
       restored scroll position harder to reason about. */
    /* A dead band around the crossing point. Without it, a finger resting
       at the boundary, or the momentum bounce at the end of a flick, flips
       the state every few pixels and the bar stutters in and out halfway
       through its own slide. It has to travel 10px past the line to change
       its mind. */
    var BAND = 10;
    var shown = false;
    var sizesReady = false;
    function place() {
      var r = anchor.getBoundingClientRect();
      var above = r.bottom <= -BAND;
      var aboveOff = r.bottom >= BAND;
      /* Below the fold too, but only once sizes are in: the shopper has
         just finished choosing and the real button may be a screen down.
         Before that, a bar saying "select your size" under the size field
         would be noise. */
      var below = sizesReady && r.top >= window.innerHeight + BAND;
      var belowOff = !sizesReady || r.top <= window.innerHeight - BAND;
      if (!shown && (above || below)) shown = true;
      else if (shown && aboveOff && belowOff) shown = false;
      else return;                       // inside the band, leave it alone
      bar.dataset.visible = shown ? 'true' : 'false';
    }
    document.addEventListener('b9r:sizes', function (e) {
      sizesReady = !!(e.detail && e.detail.ready);
      place();
    });

    /* Coalesce to one measurement per frame so a flick does not queue a
       hundred layout reads, and always run a trailing one: a throttle that
       only drops events can swallow the last scroll of a gesture and leave
       the bar in the wrong state until the next touch. */
    var frame = null;
    var trailing = null;
    function measure() {
      frame = null;
      place();
    }
    function onScroll() {
      if (frame === null) {
        frame = window.requestAnimationFrame
          ? window.requestAnimationFrame(measure)
          : window.setTimeout(measure, 16);
      }
      window.clearTimeout(trailing);
      trailing = window.setTimeout(measure, 90);
    }

    /* First read is unconditional: `shown` starts false, and a page restored
       mid-scroll needs the bar placed before anyone touches anything. */
    bar.dataset.visible = anchor.getBoundingClientRect().bottom <= 0 ? 'true' : 'false';
    shown = bar.dataset.visible === 'true';
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('orientationchange', onScroll);

    /* When a buy box is on the page it owns this button. This is only
       the fallback for a sticky bar rendered without one. */
    var jump = bar.querySelector('[data-b9r-sticky-jump]');
    if (jump && !document.querySelector('[data-b9r-buybox]')) {
      jump.addEventListener('click', function (event) {
        event.preventDefault();
        /* Aim at the first empty size field of the selected tier, so the tap
           lands where the shopper actually has something to do. */
        var target =
          document.querySelector('[data-b9r-sizes]:not([hidden]) [data-b9r-unit-size]:not([disabled])') ||
          document.querySelector('[data-b9r-size]') ||
          anchor;
        scrollToField(target);
        window.setTimeout(function () {
          if (target.focus) target.focus({ preventScroll: true });
        }, 450);
      });
    }
  }

  /* ------------------------------------------------- stock counter ----- */
  /* The number is generated, not read from inventory. It is held in
     sessionStorage so it stays put while the shopper is on the page
     rather than changing under them on every render. */
  function initScarcity(el) {
    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    if (isNaN(min)) min = 3;
    if (isNaN(max)) max = 11;
    if (min < 2) min = 2;              // never shows 1 or 0
    if (max < min) max = min;

    var key = 'b9r-stock-' + min + '-' + max;
    var count;
    try { count = window.sessionStorage.getItem(key); } catch (e) { count = null; }

    if (!count) {
      count = String(Math.floor(Math.random() * (max - min + 1)) + min);
      try { window.sessionStorage.setItem(key, count); } catch (e) {}
    }

    var label = el.querySelector('span:last-child');
    if (label) label.textContent = label.textContent.replace('[count]', count);
  }

  /* ------------------------------------------------- sticky promo bar -- */
  function initPromo(bar) {
    if (!bar.classList.contains('b9r-promo--sticky')) return;
    var spacer = bar.parentNode.querySelector('[data-b9r-promo-spacer]');
    if (!spacer) return;

    function size() { var h = bar.offsetHeight; if (h > 0) spacer.style.height = h + 'px'; }   // never collapse to 0: the CSS height holds until the bar is measurable

    size();
    window.addEventListener('resize', size);
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(bar);
    // Fonts landing late can change the bar's height.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
  }

  /* -------------------------------------------------- smart header --- */
  /* Scroll down: the logo row scrolls away as normal. Past it, scrolling up
     slides it back in directly under the fixed sale bar; scrolling down
     tucks it away again. Back at the top it drops into its own place with
     no jump. It animates `top`, never `transform`, so the menu drawer inside
     keeps positioning against the viewport. */
  function initSmartHeader(bar) {
    if (bar.dataset.b9rSmartHeader !== 'true' || bar.__b9rSmart) return;
    var wrap = document.querySelector('.section-header .header-wrapper');
    var section = wrap && wrap.closest('.section-header');
    if (!section) return;
    bar.__b9rSmart = true;

    var root = document.documentElement;
    var pinned = false, shown = false, lastY = window.pageYOffset, ticking = false;

    function promoH() { return bar.classList.contains('b9r-promo--sticky') ? bar.offsetHeight : 0; }
    function measure() {
      root.style.setProperty('--b9r-promo-h', promoH() + 'px');
      root.style.setProperty('--b9r-hdr-h', wrap.offsetHeight + 'px');
    }
    function sectionTop() { return section.getBoundingClientRect().top + window.pageYOffset; }
    function pin() {
      if (pinned) return;
      section.style.minHeight = wrap.offsetHeight + 'px';
      wrap.classList.add('b9r-hdr--fixed');
      pinned = true;
    }
    function unpin() {
      if (!pinned) return;
      wrap.classList.remove('b9r-hdr--fixed', 'b9r-hdr--shown');
      section.style.minHeight = '';
      pinned = false; shown = false;
    }
    function show(on) {
      if (shown === on) return;
      shown = on;
      wrap.classList.toggle('b9r-hdr--shown', on);
    }
    function update() {
      ticking = false;
      var y = window.pageYOffset;
      var top = sectionTop();
      var h = wrap.offsetHeight;
      var under = y + promoH();                  // the line just below the sale bar
      if (shown ? under <= top : under < top + h) {
        unpin();                                 // its own spot is on screen: sit there
      } else {
        pin();
        if (Date.now() < (window.__b9rHdrHold || 0)) show(false);   // a button is moving the page
        else if (y < lastY - 6) show(true);      // scrolling up
        else if (y > lastY + 6) show(false);     // scrolling down
      }
      lastY = y;
    }

    measure();
    window.addEventListener('resize', function () { measure(); update(); });
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(bar);
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ----------------------------------------------------- size chart --- */
  function initSizeChart(dialog) {
    var openers = document.querySelectorAll('[data-b9r-sizechart-open]');
    if (!openers.length) return;

    // Nothing here may move the page. Repositioning the body (the usual
    // iOS scroll-lock trick) means restoring the scroll on the way out, and
    // any drift there reads as a jump. Hiding overflow on the root holds the
    // reader exactly where they are, so there is nothing to restore.
    var locked = false;
    var pad = '';
    function lock() {
      if (locked) return;
      locked = true;
      var root = document.documentElement;
      // the scrollbar disappears with the overflow, so pay its width back
      // as padding or the page shifts sideways under the backdrop
      var gap = window.innerWidth - root.clientWidth;
      pad = root.style.paddingRight;
      if (gap > 0) root.style.paddingRight = gap + 'px';
      root.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';   // iOS Safari needs both
    }
    function unlock() {
      if (!locked) return;
      locked = false;
      document.documentElement.style.overflow = '';
      document.documentElement.style.paddingRight = pad;
      document.body.style.overflow = '';
    }

    var lastOpener = null;
    function open(btn) {
      lastOpener = btn || null;
      lock();
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');    // no <dialog> support
    }
    function close() {
      if (dialog.close) dialog.close();
      else dialog.removeAttribute('open');
      unlock();                                 // no-op if 'close' beat us here
      // Browsers return focus to the opener and scroll it into view; asking
      // for it ourselves with preventScroll keeps the page still.
      if (lastOpener && lastOpener.focus) {
        try { lastOpener.focus({ preventScroll: true }); } catch (e) { }
      }
    }
    // Esc closes the dialog without going through our button.
    dialog.addEventListener('close', unlock);

    openers.forEach(function (btn) {
      if (btn.dataset.b9rSizechartBound) return;
      btn.dataset.b9rSizechartBound = '1';
      btn.addEventListener('click', function (e) { e.preventDefault(); open(btn); });
    });
    dialog.querySelectorAll('[data-b9r-sizechart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    // Click on the backdrop, which lands on the dialog element itself.
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
  }

  /* --------------------------------------------------- video reviews --- */
  function initVidwall(root) {
    // the section loads the script a second time, so boot() can reach this
    // twice and would append a second set of dots
    if (root.dataset.b9rVidwallReady) return;
    root.dataset.b9rVidwallReady = '1';
    var track = root.querySelector('[data-b9r-vidwall-track]');
    if (!track) return;
    var cards = [].slice.call(track.children);
    if (!cards.length) return;

    // Always open on the first card. Phones (iOS Safari especially) restore
    // a slider's old swipe position on reload and back/forward, so a shopper
    // could land mid-row with the insoles card off screen.
    function toStart() { track.scrollLeft = 0; }
    toStart();
    window.addEventListener('pageshow', toStart);

    // One video at a time: starting a second one stops the first.
    var videos = [].slice.call(root.querySelectorAll('video'));
    // The button and the thumbnail are separate states. Before a video has ever
    // run, both show. Pause it halfway and only the button comes back - covering
    // the frame he stopped on with a poster would read as a glitch.
    function parts(node) {
      var wrap = node.parentNode || {};
      return {
        wrap: wrap,
        btn: wrap.querySelector ? wrap.querySelector('[data-b9r-vidwall-play]') : null,
        poster: wrap.querySelector ? wrap.querySelector('.b9r-vidpost__poster') : null,
        bar: wrap.querySelector ? wrap.querySelector('[data-b9r-vidwall-bar]') : null,
        fill: wrap.querySelector ? wrap.querySelector('[data-b9r-vidwall-fill]') : null,
        spin: wrap.querySelector ? wrap.querySelector('.b9r-vidpost__spin') : null
      };
    }

    // Nothing is buffered until the tap (preload is off, on purpose), so the
    // video element has no frame to paint and shows black while it fetches.
    // The thumbnail has to stay up until playback actually produces a frame.
    function spinner(video, on) {
      var p = parts(video);
      var el = p.spin;
      if (!el && on && p.wrap.appendChild) {
        el = document.createElement('span');
        el.className = 'b9r-vidpost__spin';
        el.setAttribute('aria-hidden', 'true');
        p.wrap.appendChild(el);
      }
      if (el) el.hidden = !on;
    }
    function rest(video, full) {
      var p = parts(video);
      spinner(video, false);
      if (p.btn) p.btn.hidden = false;
      if (p.poster) p.poster.hidden = !full;
      if (p.bar) p.bar.hidden = full;
      if (full && p.fill) p.fill.style.width = '0%';
    }
    root.querySelectorAll('[data-b9r-vidwall-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = btn.parentNode.querySelector('video');
        if (!video) return;
        videos.forEach(function (other) {
          if (other === video) return;
          other.pause();
        });
        var p = parts(video);
        if (p.btn) p.btn.hidden = true;
        if (p.bar) p.bar.hidden = false;
        // the poster stays until the `playing` handler below sees a real frame
        if (video.readyState < 3) spinner(video, true);
        var played = video.play();
        // playback can be refused; put the button back rather than leave a dead frame
        if (played && played.catch) played.catch(function () { rest(video, true); });
      });
    });
    videos.forEach(function (video) {
      var p = parts(video);

      // Two pictures were stacked in one box. `video_tag` gives the element its
      // own poster - Shopify's auto grab of the first frame - and the custom
      // thumbnail is a separate lazy <img> laid over it. The element's poster
      // paints at once, the <img> arrives later, and the swap between two
      // different photos is the flicker around a tap. Drop the auto one, then
      // point the element at the very file the <img> settled on, so both layers
      // are the same picture and there is nothing left to swap. Waiting for the
      // <img> to load means that URL is already cached - no extra request.
      if (p.poster) {
        video.removeAttribute('poster');
        var syncPoster = function () {
          var src = p.poster.currentSrc || p.poster.getAttribute('src');
          if (src) video.poster = src;
        };
        if (p.poster.complete && p.poster.naturalWidth) syncPoster();
        else p.poster.addEventListener('load', syncPoster, { once: true });
      }

      // Tap the frame itself to stop, the way every short-form player behaves.
      video.addEventListener('click', function () {
        if (!video.paused) video.pause();
      });
      // Frames are flowing now, so the thumbnail can come down - but not on
      // `playing` itself. Safari fires that a beat before the first frame is
      // composited, and on a phone that frame can arrive in tiles, left one
      // last. Dropping the thumbnail there showed a half-painted frame for an
      // instant. requestVideoFrameCallback fires only once a frame has been
      // presented, which is the moment the thumbnail is actually redundant.
      video.addEventListener('playing', function () {
        spinner(video, false);
        var reveal = function () { if (p.poster) p.poster.hidden = true; };
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(function () { reveal(); });
        } else {
          var onFrame = function () {
            if (video.currentTime > 0) { reveal(); video.removeEventListener('timeupdate', onFrame); }
          };
          video.addEventListener('timeupdate', onFrame);
        }
      });
      // Mid-clip rebuffer: show the spinner again, but never the poster - that
      // would flash his own face back over the middle of the video.
      video.addEventListener('waiting', function () {
        if (!video.paused) spinner(video, true);
      });
      video.addEventListener('timeupdate', function () {
        if (!p.fill || !video.duration) return;
        p.fill.style.width = (video.currentTime / video.duration * 100) + '%';
      });
      video.addEventListener('pause', function () {
        // mid-video: offer the button back but keep his frame and the bar
        rest(video, video.ended || video.currentTime === 0);
      });
      video.addEventListener('ended', function () { rest(video, true); });
      // Scrub. The bar is a 16px strip so a thumb can hit a 4px line.
      if (p.bar) {
        var seek = function (clientX) {
          var r = p.bar.getBoundingClientRect();
          if (!video.duration || !r.width) return;
          var ratio = Math.min(Math.max((clientX - r.left) / r.width, 0), 1);
          video.currentTime = ratio * video.duration;
          if (p.fill) p.fill.style.width = (ratio * 100) + '%';
        };
        p.bar.addEventListener('click', function (e) { e.stopPropagation(); seek(e.clientX); });
        p.bar.addEventListener('touchmove', function (e) {
          if (e.touches && e.touches[0]) seek(e.touches[0].clientX);
        }, { passive: true });
      }
    });
    // Swiping the carousel, or scrolling the section out of view, has to stop
    // playback too - otherwise a card keeps talking from off screen. Anything
    // less than half in view is not being watched, and it goes all the way back
    // to its opening state rather than sitting on a stale half-played frame.
    if (typeof IntersectionObserver === 'function') {
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) return;
          var video = entry.target;
          if (video.paused && !video.currentTime) return;   // already at rest
          video.pause();
          video.currentTime = 0;
          rest(video, true);
        });
      }, { threshold: 0.55 });
      videos.forEach(function (video) { watcher.observe(video); });
    }

    var dotWrap = root.querySelector('[data-b9r-vidwall-dots]');
    var prev = root.querySelector('[data-b9r-vidwall-prev]');
    var next = root.querySelector('[data-b9r-vidwall-next]');
    var dots = [];

    function sliding() {
      // desktop lays all four out flat, so there is nothing to page through
      return track.scrollWidth - track.clientWidth > 4;
    }
    function current() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestGap = Infinity;
      cards.forEach(function (card, i) {
        var centre = card.offsetLeft + card.offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < bestGap) { bestGap = gap; best = i; }
      });
      return best;
    }
    function goTo(i) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (!card) return;
      var left = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { track.scrollTo({ left: left, behavior: reduced ? 'auto' : 'smooth' }); }
      catch (e) { track.scrollLeft = left; }
    }

    if (dotWrap) {
      cards.forEach(function (card, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'b9r-vidwall__dot';
        dot.setAttribute('aria-label', 'Review ' + (i + 1));
        dot.addEventListener('click', function () { goTo(i); });
        dotWrap.appendChild(dot);
        dots.push(dot);
      });
    }

    function sync() {
      var on = sliding();
      var i = current();
      dots.forEach(function (dot, n) { dot.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      if (dotWrap) dotWrap.style.display = on ? '' : 'none';
      // Shown at every width: on a phone the next arrow is what tells people
      // to swipe. An arrow with nowhere to go fades out rather than greying.
      if (prev) { prev.disabled = i <= 0; prev.style.display = on ? 'grid' : 'none'; }
      if (next) { next.disabled = i >= cards.length - 1; next.style.display = on ? 'grid' : 'none'; }
    }

    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });

    var frame = null;
    track.addEventListener('scroll', function () {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(function () { frame = null; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ------------------------------------------------- centred section heads --- */
  // A fixed measure on the lede either overshoots a short heading or falls
  // short of a long one. Cap each lede at its own heading's longest line so
  // every centred head reads as one column, whatever the heading says.
  var LEDE_MIN = 340;
  var LEDE_MAX = 620;
  function syncLedes(scope) {
    (scope || document).querySelectorAll('.b9r__head--center').forEach(function (head) {
      var heading = head.querySelector('h2');
      var lede = head.querySelector('.b9r__lede');
      if (!heading || !lede) return;
      lede.style.maxWidth = '';
      var range = document.createRange();
      range.selectNodeContents(heading);
      var rects = range.getClientRects();
      var widest = 0;
      for (var i = 0; i < rects.length; i++) {
        if (rects[i].width > widest) widest = rects[i].width;
      }
      if (!widest) return;
      var room = head.clientWidth;
      var min = Math.min(LEDE_MIN, room);
      var max = Math.min(LEDE_MAX, room);
      lede.style.maxWidth = Math.round(Math.max(min, Math.min(max, widest))) + 'px';
    });
  }

  var ledeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(ledeTimer);
    ledeTimer = setTimeout(function () { syncLedes(document); }, 120);
  });
  // A late webfont changes the heading's line breaks, and so its widest line.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { syncLedes(document); });
  }

  /* --------------------------------------------------------- reveals --- */
  // Rows lift in as their block arrives, and any figure inside counts up to the
  // number already in the markup. If the browser never runs a frame, or the
  // reader has asked for less motion, the final number is what was there all
  // along: nothing to restore, nothing to go wrong.
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el) {
    var raw = (el.getAttribute('data-value') || '').replace(/[^0-9.]/g, '');
    var target = parseFloat(raw);
    if (isNaN(target)) return;
    var grouped = /,/.test(el.getAttribute('data-value') || '');
    var suffix = el.getAttribute('data-suffix') || '';
    function fmt(n) { return grouped ? n.toLocaleString('en-US') : String(n); }
    var start = null;
    var span = 1100;
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / span);
      // ease-out, so it lands rather than stops
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = fmt(Math.round(target * eased)) + suffix;
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function initReveal(root) {
    if (root.dataset.b9rRevealReady) return;
    root.dataset.b9rRevealReady = '1';
    var figures = root.querySelectorAll('[data-b9r-stat]');
    if (REDUCED || !('IntersectionObserver' in window)) {
      root.classList.add('is-in');
      return;
    }
    root.setAttribute('data-b9r-reveal', '');
    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      root.classList.add('is-in');
      for (var i = 0; i < figures.length; i++) countUp(figures[i]);
      io.disconnect();
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) show(); });
    }, { threshold: 0.25 });
    io.observe(root);
    // Insurance: hidden copy is worse than no animation. If the block is already
    // on screen and the observer has not spoken up, show it anyway.
    setTimeout(function () {
      if (shown) return;
      var r = root.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) show();
    }, 1500);
  }

  /* -------------------------------------------------------- timeline --- */
  // The rail fills as the reader comes down the page: progress is measured from
  // the first icon to the last, against a line two-thirds down the viewport, so
  // the line is full by the time the last stage is being read.
  function initTimeline(root) {
    if (root.dataset.b9rTimelineReady) return;
    root.dataset.b9rTimelineReady = '1';
    var fill = root.querySelector('[data-b9r-timeline-fill]');
    var icons = root.querySelectorAll('.b9r-timeline__icon');
    if (!fill || icons.length < 2) return;
    if (REDUCED) { root.style.setProperty('--b9r-tl-progress', 1); return; }

    var ticking = false;
    function measure() {
      ticking = false;
      var first = icons[0].getBoundingClientRect();
      var last = icons[icons.length - 1].getBoundingClientRect();
      var start = first.top + first.height / 2;
      var end = last.top + last.height / 2;
      var mark = window.innerHeight * 0.66;
      var span = end - start;
      var p = span <= 0 ? 1 : (mark - start) / span;
      root.style.setProperty('--b9r-tl-progress', Math.max(0, Math.min(1, p)).toFixed(3));
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    measure();
  }

  /* ------------------------------------------------- step loop video --- */
  /* The step clips carry `autoplay` in the markup so they still run with JS
     off. All this does is stop the ones nobody is looking at: four muted
     clips decoding at once is real battery and real jank on a phone. */
  function initStepVideo(video) {
    if (video.dataset.b9rLooped) return;
    video.dataset.b9rLooped = '1';

    video.muted = true;
    video.loop = true;
    video.playsInline = true;

    if (typeof IntersectionObserver !== 'function') {
      if (video.dataset.b9rPoster) video.poster = video.dataset.b9rPoster;
      return;
    }

    // the poster is held back in the markup; give it back a screen or so early
    if (video.dataset.b9rPoster) {
      var near = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        near.disconnect();
        if (!video.poster) video.poster = video.dataset.b9rPoster;
      }, { rootMargin: '900px 0px' });
      near.observe(video);
    }

    var watcher = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var playing = entry.target.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (!entry.target.paused) {
          entry.target.pause();
        }
      });
    }, { threshold: 0.2 });

    watcher.observe(video);
  }

  /* ------------------------------------------------------------ boot --- */
  /* A gift name and its bracket share one line at every width. Where a
     column is too narrow for both, the name steps down half a point at a
     time (to 12.5px) rather than dropping the bracket under itself. Runs on
     load and resize; the tiers are static markup so nothing else re-renders
     them. */
  function fitGiftNames(scope) {
    return;   // the rows now size themselves in CSS (the name spans the row); kept for a narrower day
    (scope || document).querySelectorAll('.b9r-gifts').forEach(function (list) {
      var labels = Array.prototype.slice.call(list.querySelectorAll('.b9r-gift__label'));
      labels.forEach(function (el) { el.style.fontSize = ''; });
      if (!labels.length || !labels[0].clientWidth) return;   // a collapsed tier: nothing to measure
      // one size for the whole list: the longest name sets it, so the rows never sit at two sizes
      var size = parseFloat(getComputedStyle(labels[0]).fontSize);
      var fits = function () {
        return labels.every(function (el) {
          var range = document.createRange();
          range.selectNodeContents(el);
          // 6px of slack: a phone renders Montserrat a hair wider than the desktop measure, and the tag must not kiss the price
          return range.getBoundingClientRect().width <= el.clientWidth - 6;
        });
      };
      while (!fits() && size > 12.5) {
        size -= 0.5;
        labels.forEach(function (el) { el.style.fontSize = size + 'px'; });
      }
    });
  }
  var fitTimer;
  window.addEventListener('resize', function () { clearTimeout(fitTimer); fitTimer = setTimeout(function () { fitGiftNames(); }, 80); });
  // a collapsed tier's gifts measure 0 wide, so fit again once a tier opens
  document.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('b9r-tier__input')) setTimeout(function () { fitGiftNames(); }, 30); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitGiftNames(); });

  function boot(scope) {
    syncLedes(scope);
    fitGiftNames(scope);
    (scope || document).querySelectorAll('[data-b9r-timeline]').forEach(initTimeline);
    (scope || document).querySelectorAll('[data-b9r-stats], [data-b9r-reveal-group]').forEach(initReveal);
    (scope || document).querySelectorAll('[data-b9r-gallery]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-b9r-acc]').forEach(initAccordion);
    (scope || document).querySelectorAll('[data-b9r-countdown]').forEach(initCountdown);
    (scope || document).querySelectorAll('[data-b9r-buybox]').forEach(initBuyBox);
    (scope || document).querySelectorAll('[data-b9r-sticky]').forEach(initSticky);
    (scope || document).querySelectorAll('.b9r-promo').forEach(initPromo);
    (scope || document).querySelectorAll('.b9r-promo').forEach(initSmartHeader);
    (scope || document).querySelectorAll('[data-b9r-scarcity]').forEach(initScarcity);
    (scope || document).querySelectorAll('[data-b9r-sizechart]').forEach(initSizeChart);
    (scope || document).querySelectorAll('[data-b9r-vidwall]').forEach(initVidwall);
    (scope || document).querySelectorAll('.b9r-step2__video').forEach(initStepVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();

/* ------------------------------------------------------ gift cards ---
   Values typed in the theme (free shipping) are in the shop's currency;
   product compare-ats already arrive in the shopper's. Convert the typed
   ones with Shopify's own rate and format them like the page's prices,
   then total the header from what the cards now say. The arrow shows only
   while there is more to swipe to, and the row nudges once on first view
   so a phone user sees it moves. */
(function () {
  var cur = window.Shopify && window.Shopify.currency;
  var rate = cur && parseFloat(cur.rate);
  if (!rate || isNaN(rate)) rate = 1;

  function fmt(cents, like) {
    // reuse the page's own money pattern from an element it already rendered
    var m = (like || '').match(/(\d[\d.,\s]*\d|\d)/);
    var dec = m && /,\d{2}$/.test(m[1]) ? ',' : '.';
    var grp = dec === ',' ? '.' : ',';
    var whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, grp);
    var num = whole + dec + ('0' + (cents % 100)).slice(-2);
    return m ? like.replace(m[1], num) : num;
  }

  document.querySelectorAll('[data-b9r-typed]').forEach(function (el) {
    var c = Math.round(parseInt(el.dataset.b9rTyped, 10) * rate);
    if (rate !== 1) el.textContent = fmt(c, el.textContent);
  });
  document.querySelectorAll('[data-b9r-gift-total]').forEach(function (el) {
    // add up the cards exactly as they read (each rounded on its own), so the
    // header never differs from the cards by a cent after conversion
    var group = el.closest('.b9r-gifts') || el.closest('.b9r-tier') || el.parentNode;
    var typedCards = group ? group.querySelectorAll('s[data-b9r-typed]') : [];
    var typedSum = 0;
    if (typedCards.length) typedCards.forEach(function (s) { typedSum += Math.round(parseInt(s.dataset.b9rTyped, 10) * rate); });
    else typedSum = Math.round(parseInt(el.dataset.typed, 10) * rate);
    var c = parseInt(el.dataset.cents, 10) + typedSum;
    if (rate !== 1) el.textContent = el.textContent.replace(/^\S+/, fmt(c, el.textContent.split(' ')[0]));
  });

  document.querySelectorAll('[data-b9r-gcards]').forEach(function (box) {
    var track = box.querySelector('.b9r-gcards__track');
    var next = box.querySelector('[data-b9r-gcards-next]');
    var prev = box.querySelector('[data-b9r-gcards-prev]');
    if (!track) return;
    function step() { var c = track.querySelector('.b9r-gcard'); return c ? c.offsetWidth + 10 : 140; }
    function update() {
      var more = track.scrollWidth - track.clientWidth - track.scrollLeft > 4;
      var back = track.scrollLeft > 4;
      box.dataset.more = more ? 'true' : 'false';
      box.dataset.back = back ? 'true' : 'false';
      if (next) next.hidden = !more;
      if (prev) prev.hidden = !back;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    update();
    // the tier may open later, so re-check when it does
    var form = box.closest('form');
    if (form) form.addEventListener('change', function () { window.requestAnimationFrame(update); });

    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting || track.scrollWidth <= track.clientWidth + 4) return;
        io.disconnect();
        window.setTimeout(function () {
          if (track.scrollLeft > 0) return;
          track.scrollTo({ left: 44, behavior: 'smooth' });
          window.setTimeout(function () { track.scrollTo({ left: 0, behavior: 'smooth' }); }, 550);
        }, 500);
      });
    }, { threshold: 0.8 });
    io.observe(track);
  });
})();

/* -------------------------------------------------- focus rings ---
   The ring is for people moving through the page with the keyboard. A
   tap or click never shows it, including the focus the size chart hands
   back to its button on close, which browsers otherwise paint. */
(function () {
  var root = document.documentElement;
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Tab' || e.key.indexOf('Arrow') === 0) root.classList.add('b9r-kbd');
  }, true);
  window.addEventListener('pointerdown', function () { root.classList.remove('b9r-kbd'); }, true);
})();
